import { createBrowserRouter, RouterProvider } from "react-router-dom";
import Layout from "./components/pages/layout";
import ErrorPage from "./components/pages/error/404";
import routes from "./utils/routes";
import { AuthProvider } from "./services/auth-services/authContext";

const router = createBrowserRouter([
  {
    element : <Layout />,
    errorElement : <ErrorPage />,
    children : routes
  }
])

function App() {
  return (
    <AuthProvider>
      <RouterProvider router={router} />
    </AuthProvider>

  );
}

export default App;
